import React from "react";
import MarketClusteringComponent from "../../components/marketClusteringComponent/MarketClusteringComponent";

const MarketClusteringContainer: React.FC<{ isTabSelected: boolean }> = ({isTabSelected}) => {
    return (<MarketClusteringComponent isTabSelected={isTabSelected} />);
};

export default MarketClusteringContainer;
